export const FIRST_ONBOARDING_ASTROLOGER_ID = "17845d77-ef64-48e2-8d82-4dc13d1164f0"

function hasUsableBirthDetails(person) {
  const birthPlace = String(person.birthPlace ?? "").trim().toLowerCase()
  const birthName = String(person.birthName ?? "").trim().toLowerCase()
  const birthDate = String(person.birthDate ?? "").trim()
  const birthTime = String(person.birthTime ?? "").trim()
  const birthTimezone = String(person.birthTimezone ?? "").trim()

  if (!birthDate || !birthPlace) {
    return false
  }

  const isPlaceholderProfile =
    birthName === "self" &&
    birthDate === "1970-01-01" &&
    birthTime === "00:00" &&
    birthPlace === "unknown" &&
    birthTimezone === "UTC"

  return !isPlaceholderProfile && birthPlace !== "unknown"
}

function getLatestConversation(conversations) {
  if (!Array.isArray(conversations) || conversations.length === 0) {
    return null
  }

  return [...conversations].sort(
    (left, right) => new Date(right.updatedAt).getTime() - new Date(left.updatedAt).getTime(),
  )[0] ?? null
}

export function getStartupRoute({ people, conversations, credits }) {
  const peopleList = Array.isArray(people) ? people : []
  const usablePeople = peopleList.filter(hasUsableBirthDetails)

  if (usablePeople.length === 0) {
    if (peopleList.length === 0) return "/onboarding"
    const fallbackPerson = peopleList.find((person) => person.isDefault) ?? peopleList[0] ?? null
    return fallbackPerson ? `/people/${encodeURIComponent(fallbackPerson.id)}/edit` : "/people/new"
  }

  if (credits <= 0) {
    return (conversations?.length ?? 0) === 0 ? "/billing?from=onboarding" : "/billing"
  }

  const latestConversation = getLatestConversation(conversations)
  if (latestConversation) {
    const params = new URLSearchParams({
      astrologerId: latestConversation.astrologerId,
      personId: latestConversation.personId,
    })
    return `/chat/new?${params.toString()}`
  }

  const preferredPerson = usablePeople.find((person) => person.isDefault) ?? usablePeople[0] ?? null
  return preferredPerson ? `/chat/new?personId=${encodeURIComponent(preferredPerson.id)}` : "/people/new"
}

export function getOnboardingBillingBannerDismissKey(userId) {
  return `askjyotish.billing.onboarding-banner.dismissed:${String(userId ?? "").trim() || "anonymous"}`
}

export function shouldShowOnboardingBillingBanner({
  isFromOnboarding,
  isDismissed,
  availableBalancePaise = 0,
}) {
  return Boolean(isFromOnboarding && !isDismissed && availableBalancePaise <= 0)
}

export function buildOnboardingChatSearchParams(personId) {
  const params = new URLSearchParams({
    onboarding: "1",
    astrologerId: FIRST_ONBOARDING_ASTROLOGER_ID,
  })
  if (personId) {
    params.set("personId", personId)
  }
  return params.toString()
}
